export default "__VITE_ASSET__DJYsqVXD__"